<template>
    <div class="CompanyNews">
        <mediaCenter tabIndex="2"></mediaCenter>
        <div :class="isMobile ? '' : 'industryBox'">
            <template v-if="!isMobile">
                <div class="industryList clearfix" v-for="item in companyNewsList" :key="item.id">
                    <div class="fl insLeft" v-if="item.picture && item.picture != 'None'">
                        <img class="coverImg" :src="item.picture" alt="">
                    </div>
                    <div class="fl insLeft" v-else>
                        <div class="fl day">{{formatDay(item.addTime)}}</div>
                        <div class="fl yearMon">
                            <p>{{formatMonth(item.addTime)}}</p>
                            <p>{{formatYear(item.addTime)}}</p>
                        </div>
                    </div>
                    <div class="fl insRight">
                        <p class="title curp biaot" @click="jumpToDetails(item)">{{item.title}}</p>
                        <p class="desc overh2">{{item.summary}}</p>
                        <p class="lookInfo" @click="jumpToDetails(item)">查看详情</p>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="industryItem" v-for="item in companyNewsList" :key="item.id">
                    <div class="mobileCoverRow" v-if="item.picture && item.picture != 'None'">
                        <img class="mobileCoverImg" :src="item.picture" alt="">
                        <div class="mobileCoverInfo">
                            <p class="titles" @click="jumpToDetails(item)">{{item.title}}</p>
                            <p class="textr c99 mt5">{{formatDate(item.addTime)}}</p>
                        </div>
                    </div>
                    <template v-else>
                        <p class="titles" @click="jumpToDetails(item)">{{item.title}}</p>
                        <p class="descs overh2">{{item.summary}}</p>
                        <p class="textr c99 mt5">{{formatDate(item.addTime)}}</p>
                    </template>
                </div>
            </template>
            <div v-if="!loading && companyNewsList.length === 0">
                <el-empty description="暂无数据"></el-empty>
            </div>
            <el-pagination
                class="pageBox"
                v-if="companyNewsList.length !== 0"
                background
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :layout="isMobile ? 'prev, pager, next' : 'prev, pager, next, jumper'"
                :pager-count="isMobile ? 5 : 7"
                :total="total"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import mediaCenter from '@/components/mediaCenter'
const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
const newApi = (path) => NEW_API_BASE + path

export default {
    name: 'CompanyNews',
    components: {
        mediaCenter
    },
    data() {
        return {
            companyNewsList: [],
            loading: true,
            currentPage: 1,
            total: 0
        }
    },
    mounted() {
        this.getCompanyNews()
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return ''
            return dateStr.split(' ')[0]
        },
        formatDay(dateStr) {
            if (!dateStr) return ''
            return dateStr.split(' ')[0].split('-')[2] + '/'
        },
        formatMonth(dateStr) {
            if (!dateStr) return ''
            return dateStr.split(' ')[0].split('-')[1] + '月'
        },
        formatYear(dateStr) {
            if (!dateStr) return ''
            return dateStr.split(' ')[0].split('-')[0]
        },
        // 获取企业动态列表
        getCompanyNews() {
            this.loading = true
            this.Request({
                url: newApi('/hzfglSys/news/public/newsList'),
                baseURL: '',
                method: 'get',
                data: {
                    pageindex: this.currentPage,
                    pagesize: 10,
                    webcode: 'web_100100',
                    years: 3
                }
            }).then((res) => {
                const data = res.data
                this.companyNewsList = (data && data.rows) || []
                this.total = (data && data.total) || 0
            }).finally(() => {
                this.loading = false
            })
        },
        jumpToDetails(item) {
            if (item.webUrl) {
                const url = /^https?:\/\//i.test(item.webUrl) ? item.webUrl : 'http://' + item.webUrl
                window.open(url, '_blank')
            } else {
                this.$router.push({ path: '/mediaCenter/CompanyNewsDetails', query: { id: item.id } })
            }
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getCompanyNews()
        }
    }
}
</script>

<style scoped>
    .industryBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 17px;
    }
    .industryList{
        padding: 35px 30px 35px 28px;
        border-bottom: 1px solid #E1E1E1;
    }
    .industryItem{
        padding: 20px;
        border-bottom: 1px solid #E1E1E1;
    }
    .mobileCoverRow{
        display: flex;
        align-items: flex-start;
        gap: 12px;
    }
    .mobileCoverImg{
        width: 100px;
        height: 70px;
        object-fit: cover;
        border-radius: 4px;
        flex-shrink: 0;
    }
    .mobileCoverInfo{
        flex: 1;
        min-width: 0;
    }
    .mobileCoverInfo .titles{
        margin-bottom: 5px;
    }
    .insLeft{
        padding-right: 38px;
        border-right: 1px solid #E1E1E1;
        padding-top: 47px;
        padding-bottom: 60px;
    }
    .coverImg{
        width: 180px;
        height: 120px;
        object-fit: contain;
        background: #f5f5f5;
        border-radius: 6px;
        margin-top: 10px;
    }
    .day{
        font-size: 42px;
    }
    .yearMon{
        font-size: 14px;
        color: #333;
        margin-top: 10px;
        margin-left: 5px;
    }
    .insRight{
        padding-left: 50px;
        width: calc(100% - 220px);
    }
    .title{
        font-size: 20px;
        font-weight: 400;
    }
    .titles{
        font-size: 18px;
    }
    .desc{
        color: #666;
        margin-top: 27px;
        line-height: 28px;
    }
    .descs{
        color: #666;
        margin-top: 15px;
        line-height: 28px;
    }
    .lookInfo{
        margin-top: 24px;
        color: #247CD6;
        cursor: pointer;
    }
    .pageBox{
        text-align: center;
        margin-top: 35px;
        margin-bottom: 42px;
    }
</style>
